import { Component, OnInit,Input } from '@angular/core';
import { PopoverController } from '@ionic/angular';

@Component({
  selector: 'app-file',
  templateUrl: './file.page.html',
  styleUrls: ['./file.page.scss'],
})
export class FilePage implements OnInit {
  @Input() file: any;
  @Input() selected_files: [];

  constructor(private popoverController: PopoverController) { }

  ngOnInit() {console.log(this.selected_files.length);
    
  }

  async ReturnOption(val) {
    this.popoverController.dismiss(val);
  }

}
